import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  CreateChatShortcutRequest,
  UpdateChatShortcutRequest,
} from '@nucleus-commerce/api-client/admin';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function useShortcutMutations(storeId: string) {
  const queryClient = useQueryClient();
  const refresh = () =>
    queryClient.invalidateQueries({ queryKey: chatSettingsKeys.shortcuts(storeId) });

  const create = useMutation({
    mutationFn: (body: CreateChatShortcutRequest) => chatSettingsApi.createShortcut(storeId, body),
    meta: { successMessage: 'chatSettings:toasts.shortcutSaved', silentError: true },
    onSuccess: refresh,
  });
  const update = useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateChatShortcutRequest }) =>
      chatSettingsApi.updateShortcut(storeId, id, body),
    meta: { successMessage: 'chatSettings:toasts.shortcutSaved', silentError: true },
    onSuccess: refresh,
  });
  const remove = useMutation({
    mutationFn: (id: string) => chatSettingsApi.deleteShortcut(storeId, id),
    meta: { successMessage: 'chatSettings:toasts.shortcutDeleted' },
    onSuccess: refresh,
  });
  return { create, update, remove };
}
